import type {
    OrderItemProductOrderChange} from "@@/shared/orders/order-events/events/order-changed-event/order-changes/order-item-product-change.order-change";
import {
    orderItemProductOrderChangeZodSchema,
} from "@@/shared/orders/order-events/events/order-changed-event/order-changes/order-item-product-change.order-change";
import z from "zod";
import type {
    OrderItemAddedOrderChange} from "./order-item-added.order-change";
import {
    orderItemAddedOrderChangeZodObject,
} from "./order-item-added.order-change";
import type {
    OrderItemBookableTimeOrderChange} from "./order-item-bookable-time.order-change";
import {
    orderItemBookableTimeOrderChangeZodObject,
} from "./order-item-bookable-time.order-change";
import type {
    OrderItemRemovedOrderChange} from "./order-item-removed.order-change";
import {
    orderItemRemovedOrderChangeZodObject,
} from "./order-item-removed.order-change";

type OrderChange =
    | OrderItemAddedOrderChange
    | OrderItemRemovedOrderChange
    | OrderItemBookableTimeOrderChange
    | OrderItemProductOrderChange;
// | PaymentMethodSwitchedOrderChange;

const orderChangeZodUnion = z.union([
    orderItemAddedOrderChangeZodObject,
    orderItemRemovedOrderChangeZodObject,
    orderItemBookableTimeOrderChangeZodObject,
    orderItemProductOrderChangeZodSchema,
    // paymentMethodSwitchedOrderChangeZodObject,
]);

const orderChangeZodSchema = orderChangeZodUnion;
const isOrderChange = (orderChange: unknown): orderChange is OrderChange => {
    if (
        orderChange &&
        typeof orderChange === "object" &&
        "_type" in orderChange &&
        orderChange._type === "ORDER_CHANGE"
    ) {
        return true;
    }
    return false;
};

export { isOrderChange, orderChangeZodSchema, orderChangeZodUnion };
export type { OrderChange };
